import React, { useState } from "react";
import axios from "axios";
import { Button, Form, Input, Modal, notification } from "antd";
import { api } from "../utils/Api";

const DriverShiftGroupNameModal = ({ open, onClose, onSuccess, group }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const onFinish = async (values) => {
		const url = api + `/shift-group/name/${group._id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoading(true);
			const { data } = await axios.patch(url, { name: values.name });
			if (data.success) {
				form.resetFields();
				onSuccess(data.message);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification(
				"error",
				"Error",
				"Error while trying to update group name",
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title="Edit Group"
			open={open}
			onCancel={onClose}
			centered
			destroyOnClose
			maskClosable={false}
			footer={[
				<Button key="cancel" size="large" onClick={onClose} disabled={loading}>
					Cancel
				</Button>,
				<Button
					key="submit"
					type="primary"
					size="large"
					loading={loading}
					onClick={() => form.submit()}
				>
					Save
				</Button>,
			]}
		>
			{contextHolder}
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				onFinish={onFinish}
				preserve={false}
			>
				<Form.Item
					name="name"
					label="Name"
					initialValue={group?.name}
					rules={[
						{ required: true, whitespace: true, message: "Name is required" },
					]}
				>
					<Input size="large" placeholder="Group name" />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default DriverShiftGroupNameModal;
